export default __webpack_public_path__ + "static/media/IconDesc_Ladder.256.610463fb.png";